export default "<!-- base component -->\r\n<router-outlet></router-outlet>\r\n"